import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import Coach from "../coach/Coach";
import CoachData from "../coachData/CoachData";
import Legend from "../legend/Legend";
import Trip from "../trip/Trip";
import useLocalStorage from "react-use-localstorage";

import Editor, { monaco } from "@monaco-editor/react";

import useDevices from "../../useDevices";

import Log from "../log/log";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
// const config = {
//   letterSpacing: 2
// }

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
});

monaco
  .init()
  .then((monaco) => {
    import("monaco-themes/themes/Monokai.json").then((data) => {
      monaco.editor.defineTheme("monokai", data);
      monaco.editor.setTheme("monokai");
    });
  })
  .catch((error) =>
    console.error("An error occurred during initialization of Monaco: ", error)
  );

function App() {
  const [host, setHost] = useLocalStorage("host", "http://localhost:7080");

  const [isEditorReady, setIsEditorReady] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPerformingAction, setIsPerformingAction] = useState(false);
  const [selectedApp, setSelectedApp] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const valueGetter = useRef();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  function handleEditorDidMount(_valueGetter) {
    setIsEditorReady(true);
    valueGetter.current = _valueGetter;
  }

  const [apps] = useDevices({
    host,
    query: 'where type="app"',
  });

  const [gateway] = useDevices({
    host,
    query: 'where type="gateway"',
    useFirst: true,
  });

  useEffect(() => {
    if (apps[0]) {
      setSelectedApp(apps[0]);
    }
  }, [apps]);

  async function saveApp() {
    setIsSaving(true);
    try {
      await selectedApp.performAction("saveCode", {
        code: valueGetter.current(),
      });
    } catch (err) {
      console.error(err);
    }
    setIsSaving(false);
  }

  async function handleAction(action, payload) {
    setIsPerformingAction(true);
    try {
      await gateway.performAction(action, payload);
    } catch (err) {
      console.error(err);
    }
    setIsPerformingAction(false);
  }

  async function onFormSubmit(event) {
    event.preventDefault();
    const action = [...event.target.elements].find(
      (el) => el.name === "action"
    );
    const payload = [...event.target.elements]
      .filter((el) => !["submit", "hidden"].includes(el.type))
      .reduce((acc, el) => {
        acc[el.name] = el.value;
        return acc;
      }, {});
    try {
      await gateway.performAction(action.value, payload);
    } catch (err) {
      setIsError(true);
      setErrorMessage(err.message);
    }
  }

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setIsError(false);
  };

  console.log(selectedAction);

  return (
    <ThemeProvider theme={darkTheme}>
      <Snackbar
        open={isError}
        autoHideDuration={5000}
        onClose={handleErrorClose}
      >
        <Alert severity="error" onClose={handleErrorClose}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <div className="App">
        <div className="nav">
          <TextField
            fullWidth
            label="Host"
            value={host}
            onChange={(event) => setHost(event.target.value)}
          ></TextField>
          {/* <select onChange={(event) => setSelectedApp(apps[event.target.selectedIndex])}>
        {apps.map((app, i) => <option key={i}>{app.name}</option>)}
      </select> */}
          <InputLabel id="select-app">App</InputLabel>
          <Select
            labelId="select-app"
            disabled={!selectedApp}
            value={selectedApp}
            onChange={(event) => setSelectedApp(event.target.value)}
          >
            {apps.map((app) => (
              <MenuItem key={app.id} value={app}>
                {app.name}
              </MenuItem>
            ))}
          </Select>
          <Button
            onClick={() => saveApp()}
            disabled={isSaving || !selectedApp}
            color={"primary"}
            variant={"contained"}
          >
            Save
          </Button>
        </div>
        <main>
          <Editor
            height="50vh"
            language="yaml"
            theme="monokai"
            value={selectedApp?.code}
            editorDidMount={handleEditorDidMount}
          />
          <aside className="footer">
            <Log host={host}></Log>
            <div className="gateway">
              <InputLabel id="select-action">Select action</InputLabel>
              <Select
                labelId="select-action"
                value={selectedAction}
                onChange={(event) => setSelectedAction(event.target.value)}
              >
                {gateway?.$actions?.map((action) => (
                  <MenuItem key={action.name} value={action}>
                    {action.name}
                  </MenuItem>
                ))}
              </Select>
              {selectedAction && (
                <form
                  className="actions"
                  method={selectedAction.method}
                  onSubmit={onFormSubmit}
                  noValidate
                >
                  {selectedAction.fields.map((field) =>
                    field.type === "boolean" ? (
                      <FormControlLabel
                        label={field.name}
                        control={
                          <Checkbox
                            key={field.name}
                            name={field.name}
                            checked={field.value}
                            value={true}
                          ></Checkbox>
                        }
                      />
                    ) : (
                      <TextField
                        key={field.name}
                        label={field.type !== "hidden" ? field.name : ""}
                        placeholder={field.name}
                        margin="normal"
                        name={field.name}
                        fullWidth={field.type !== "hidden"}
                        hidden={field.type === "hidden"}
                        value={field.value}
                        multiline={["payload", "software"].includes(field.name)}
                        type={field.type === "hidden" ? "hidden" : "text"}
                      ></TextField>
                    )
                  )}
                  <Button variant={"contained"} color={"primary"} type="submit">
                    Go!
                  </Button>
                </form>
              )}
            </div>
          </aside>
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;
